import { render, staticRenderFns } from "./pricing-switch.vue?vue&type=template&id=7d96a856&scoped=true&"
import script from "./pricing-switch.vue?vue&type=script&lang=ts&"
export * from "./pricing-switch.vue?vue&type=script&lang=ts&"
import style0 from "./pricing-switch.vue?vue&type=style&index=0&id=7d96a856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96a856",
  null
  
)

export default component.exports